import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { ShopManager, Store } from '../../store/invoice/useGetCharge';
import { convertCurrency } from '../../helpers/convertCurrency';
import { CellWithTooltip } from '../../components/DataView/EditableTable';

export const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];

export const columnsCharge: ColumnsType = [
    {
        title: 'ID lojista',
        dataIndex: 'store',
        key: 'store',
        width: 89,
        ellipsis: true,
        align: 'center',
        render: (store: Store) => store?.shopmanager_id,
    },
    {
        title: 'E-mail lojista',
        dataIndex: 'store',
        key: 'store',
        width: 180,
        ellipsis: true,
        align: 'center',
        render: (store: Store) => store.shopManager?.user?.email,
    },
    {
        title: 'Loja',
        dataIndex: 'store',
        key: 'store',
        width: 180,
        ellipsis: true,
        align: 'center',
        render: (store: Store) => store?.name,
    },
    {
        title: 'Mês',
        dataIndex: 'reference_date',
        key: 'reference_date',
        width: 80,
        ellipsis: true,
        align: 'center',
        render: (referenceDate: string) =>
            referenceDate ? months[moment(referenceDate).month()] : '-',
    },
    {
        title: 'Valor cobrado automaticamente',
        dataIndex: 'automatic_monthly_fee',
        key: 'automatic_monthly_fee',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (inhouseTax: number) => {
            return (
                <CellWithTooltip
                    valueCell={convertCurrency('', inhouseTax)}
                    ptbrCurrency
                />
            );
        },
    },
    {
        title: 'Valor a ser pago via boleto',
        dataIndex: 'monthly_invoice',
        key: 'monthly_invoice',
        width: 140,
        ellipsis: true,
        align: 'center',
        render: (monthlyInvoice: number) => {
            return (
                <CellWithTooltip
                    valueCell={convertCurrency('', monthlyInvoice)}
                    ptbrCurrency
                />
            );
        },
    },
];
